import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ToastProvider } from '@/components/ui/toast';
import { ApiError } from '@/lib/api-client';
import { routeur } from '@/router';
import './index.css';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (tentatives, erreur) => {
        // Inutile de réessayer une erreur de saisie ou une session expirée.
        if (erreur instanceof ApiError && erreur.status < 500) return false;
        return tentatives < 2;
      },
    },
    mutations: { retry: false },
  },
});

const racine = document.getElementById('root');
if (!racine) throw new Error('Élément #root introuvable');

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <ToastProvider>
        <RouterProvider router={routeur} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
